const API_BASE = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8787'
const FRIDAY_TOKEN_KEY = 'friday_token'

export type AuditAction =
  | 'login_success'
  | 'login_failure'
  | 'logout'
  | 'engagement_created'
  | 'engagement_stage_changed'
  | 'engagement_deleted'
  | 'pursuit_created'
  | 'pursuit_stage_changed'
  | 'contact_created'
  | 'contact_updated'
  | 'note_created'
  | 'note_deleted'
  | 'ai_feature_used'
  | 'settings_changed'
  | 'suspicious_rapid_requests'

interface AuditPayload {
  action: AuditAction
  entity_type?: string
  entity_id?: string
  metadata?: Record<string, unknown>
}

// Fire-and-forget — never awaited, never blocks UI
export function audit(payload: AuditPayload): void {
  const token = sessionStorage.getItem(FRIDAY_TOKEN_KEY)
  if (!token) return // No audit log without an authenticated session

  fetch(`${API_BASE}/audit`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  }).catch(() => {
    // Swallow silently — audit log failure must never impact the user
  })
}
